"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslatableContext = void 0;
var react_1 = require("react");
exports.TranslatableContext = react_1.createContext(undefined);
